module.exports = __webpack_public_path__ + "img/Debora_Suarez.537f9abc.jpg";